"use strict";

/**
 * Product impressions slider
 */

import $ from "jquery";
import Toolbox from "./toolbox";
import "../vendor/slick";


var productImpressionsData = {};

function addProductImpressions() {
	var localStorageKey = "productImpressions";

	if (!document.body.classList.contains("page-product")) {
		return false;
	}

	var productArticle = document.querySelector(".product-article");

	if (!productArticle) {
		return false;
	}

	var productImpression = {
		id: productArticle.dataset.productId
			? productArticle.dataset.productId
			: false,
		colour: productArticle.dataset.productColor
			? productArticle.dataset.productColor
			: ""
	};

	if (!productImpression.id) {
		return false;
	}

	var currentimpression = productImpression.id + "_" + productImpression.colour;

	productImpressionsData.currentimpression = currentimpression;

	var productImpressions = {
		modified: new Date(),
		impressions: []
	};

	if (localStorage.getItem(localStorageKey)) {
		var storedImpressions = Toolbox.readLs(localStorageKey);

		//Day: 86400000, two weeks: 1209600000.
		if (new Date() - new Date(storedImpressions.modified) > 1209600000) {
			//Clear all impressions if latest was over two weeks old.
			storedImpressions.impressions = [];
		}
		productImpressions.impressions = storedImpressions.impressions;

		if (productImpressions.impressions.indexOf(currentimpression) > -1) {
			var oldIndex = productImpressions.impressions.indexOf(currentimpression);
			productImpressions.impressions.splice(oldIndex, 1);
		}

		productImpressions.impressions.unshift(currentimpression);
		productImpressions.impressions = productImpressions.impressions.slice(
			0,
			10
		);
		Toolbox.writeLs(localStorageKey, productImpressions);
	} else {
		productImpressions.impressions = [currentimpression];
		Toolbox.writeLs(localStorageKey, productImpressions);
	}
}

/**
 * Get stored product impressions and fetch products from Stage when slider is near viewport.
 */
function addSlider() {

	const sliderContainerSelector = ".product-impressions-slider";
	const localStorageKey = "productImpressions";

	const productImpressionsSliders = document.querySelectorAll(sliderContainerSelector);

	if (productImpressionsSliders.length === 0) {
		return false;
	} else {
		for (const productImpressionsSlider of productImpressionsSliders) {
			productImpressionsSlider.dataset.state = "unloaded";
		}
	}

	addProductListLazyloader();
	checkSliderVisiblity();

	function productImpressionsScrollListener() {
		Toolbox.throttle(function () {
			checkSliderVisiblity();
		}, 500, "checkSliderVisiblityImpressions");
	}

	function addProductListLazyloader() {
		window.addEventListener(
			"scroll",
			productImpressionsScrollListener, Toolbox.listenerOptions()
		);
	}

	function checkSliderVisiblity() {
		let allDone = true;

		for (const productImpressionsSlider of productImpressionsSliders) {
			if (productImpressionsSlider.dataset.state === "unloaded") {
				allDone = false;
				if (
					window.scrollY + window.outerHeight + 200 >
					productImpressionsSlider.offsetTop
				) {
					fetchProductImpressions(productImpressionsSlider);
				}
			}
		}

		if (allDone) {
			window.removeEventListener(
				"scroll",
				productImpressionsScrollListener, Toolbox.listenerOptions()
			);
		}

	}

	function renderSliders(state, content) {
		var sliders = document.querySelectorAll(sliderContainerSelector);

		for (var i = 0; i < sliders.length; i++) {
			var sliderElement = sliders[i];

			if (state) {
				sliderElement.dataset.state = state;

				switch (state) {
					case "error":
						sliderElement.style.display = "none";
						break;

					case "done":
						if (content && content !== "") {
							sliderElement.innerHTML = content;
						} else {
							sliderElement.style.display = "none";
						}
						break;

					default:
						break;
				}
			}
		}

		if (sliders.length > 0) {
			initialiseSlickSlider();
		}
	}

	function initialiseSlickSlider() {
		const config = {
			arrows: true,
			draggable: true,
			focusOnSelect: false,
			speed: 300,
			infinite: true,
			variableWidth: true,
			slidesToShow: 5,
			slidesToScroll: 5,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						variableWidth: false,
						slidesToShow: 3,
						slidesToScroll: 3
					}
				},
				{
					breakpoint: 768,
					settings: {
						variableWidth: false,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		};

		$(sliderContainerSelector + " .product-list.slider-lazy").slick(config);
	}

	function fetchProductImpressions(productImpressionsSlider) {
		if (productImpressionsSlider.dataset.state === "loading" || !productImpressionsSlider) {
			return false;
		}

		const storedImpressions = Toolbox.readLs(localStorageKey);
		if (!storedImpressions) {
			renderSliders("done", "");
			return false;
		}

		//Do not show the product that's currently visible.
		if (
			productImpressionsData.currentimpression &&
			storedImpressions.impressions[0] ===
			productImpressionsData.currentimpression
		) {
			storedImpressions.impressions.shift();
		}

		if (storedImpressions.impressions.length === 0) {
			renderSliders("done", "");
			return false;
		}

		const productImpressionsParams = encodeURIComponent(
			storedImpressions.impressions.join("|")
		);

		const request = new XMLHttpRequest();
		request.open(
			"GET",
			"/stage-ajax/getProductImpressions/?impressions=" +
			productImpressionsParams,
			true
		);

		request.onload = function () {
			if (request.status >= 200 && request.status < 400) {
				const result = request.responseText;
				const feetched = JSON.parse(result);

				if (feetched.state === "ok") {
					renderSliders("done", feetched.response);
				} else {
					renderSliders("error");
				}
			} else {
				console.log("Couldn't load product impressions slider.");
				renderSliders("error");
			}
		};

		request.onerror = function () {
			console.log("Couldn't load product impressions slider.");
			renderSliders("error");
		};

		request.send();
		productImpressionsSlider.dataset.state = "loading";
	}
}

export { addProductImpressions, addSlider };
